<era-panel>
  <ml-sk-spinner-3 [hidden]="profile$ | async"></ml-sk-spinner-3>

  <ml-mdm-apple-profile [profile]="profile$ | async"></ml-mdm-apple-profile>
  @if ((profile$ | async) === undefined || null) {
    <div class="d-flex h-100 align-items-center">
      <p class="text-center text-muted ms-auto p-4">Please select a profile from the list.</p>
    </div>
  }
  <era-panel-footer>
    @if (profile$ | async; as profile) {
      <div class="btn-toolbar p-1 bg-gray-100 border-top">
        <ml-mdm-command-spinner [commandProgress]="removeProfilesProgress$"
                                [small]="true"
                                [direction]="'right'"
                                [reverse]="true"
                                class="flex-grow-1 text-end">
          @if (udid$ | async; as udid) {
            <button type="button"
                    (click)="remove(udid, profile)"
                    class="btn btn-outline-primary border-0">
              <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
            </button>
          }
        </ml-mdm-command-spinner>
      </div>
    }
  </era-panel-footer>
</era-panel>